module.exports = __webpack_public_path__ + "img/banner2.12c93175.png";